const component = {
  template: `
    <div class="alternatingCircText">
      <div class="alternatingCircText__section" ng-repeat="section in $ctrl.section">
        <div class="alternatingCircText__img" style="background-image:url({{section.image}});">

        </div>
        <div class="alternatingCircText__content">
          <h2 class="alternatingCircText__header" ng-bind-html="section.header"></h2>
          <p class="alternatingCircText__text" ng-bind-html="section.text"></p>
          <div class="alternatingCircText__buttons">
            <a ng-repeat="button in section.buttons" href="{{button.url}}">{{button.title}}</a>
          </div>
        </div>
      </div>
    </div>
  `,
  bindings: {
    id: '@',
    sections: '@'
  },
  controller() {
    this.$onInit = () => {
      this.section = JSON.parse(decodeURIComponent(this.sections));
    };
  }
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/alternatingCircText/index.js